export const Welcome_title = 'Bem vindo ao backoffice da aplicação.';
export const P404_title = 'Desculpe, mas a página não foi encontrada';
export const RECOVER_TITLE = 'Para poder aceder novamente à aplicação, terá de efectuar um novo registo.';
export const RECOVER_TEXT = 'Esta ação é irreversivel. Irá apagar todos os dados relacionados com a sua conta. Para proceder carregue em apagar conta e introduza o seu número de colaborador e a palavra-passe.';
export const removeRegister = 'Registo eliminado com sucesso';
export const saveRegister = 'Registo guardado com sucesso';
export const editRegister = 'Registo editado com sucesso';
export const doubleRegister = 'Registo duplicado com sucesso';
export const error =
  'Não foi possível realizar a operação pretendida. Contacta o suporte da aplicação.';
export const notNull = 'Campo obrigatório';
export const codeError = 'Código errado';
export const errorLog = 'Email ou senha incorretos.';
export const passWrong = 'A palavra passe deve ter no mínímo 8 carateres.';
export const passDifferents = 'Palavras passe não condiz';
export const INVALID_CREDENTIALS = 'Credenciais inválidas';
export const recoverPass = 'Palavra passe alterada com sucesso.';
export const dataRemove = 'Data excluída com sucesso.';
export const delRegister = 'Pretende confirmar a exclusão do registo?';
export const noTurnos = 'Não existem turnos registados.';
export const noDay = 'Não existem registos para a pesquisa.';
export const noData = 'Não existem registos para a consulta.';
export const WORD = 'cEDv10OMn4Jt';
export const DEVICE = 'Backoffice';
export const SentEmal = 'O email foi enviado com sucesso.';
export const errorApollo = 'Houve um erro no servidor, por fovar tente mais tarde ou contate o suporte da aplicação.'

export const Login = 'Login no backoffice da Eapp';
export const Code2FA = 'Code 2FA';
export const UnsubTitle = 'Cancelar Inscrição';

export const confirmUnsub = 'Sua inscrição foi cancelada com sucesso.';
export const UnsubText = 'Se realmente deseja cancelar a sua inscrição por favor, confirme clicando no botão abaixo.';








export const NO_ERROR = "no_error";
export const ALREADY_LOGGED_IN = "user_already_logged_in";
export const WRONG_USER_OR_PASS = "email_or_password_wrong";
export const WORKER_NOT_ACTIVE = "worker_number_not_active";

//export const WORKER_ALREADY_REGISTERD = 'worker_number_already_registered';
export const EMAIL_ALREADY_REGISTERED = "Este email já foi registado.";
export const NO_DEVICE_ID = "no_device_id";
export const accountRemove = 'Conta excluída com sucesso.';
export const OK = "Ok";
export const WORKER_ALREADY_REGISTERD = "Número de colaborador já registado";
export const WORKER_DOES_NOT_EXIST = "Número de colaborador inexistente";
export const EMPTY_FIELD = "Campo obrigatório";
export const EMAIL_FAILED = "E-mail incorreto ou inexistente";
export const EMAIL_DELETED = "Sua conta foi deletada entre em contato com o suporte.";
export const NAME_FAILED = "Nome incorreto";
export const PASS_WRONG = "A palavra passe deve ter no minímo 8 caracteres.";
export const PASS_DIFERENTS = "Palavras passe não condizem";
export const PASS_ORIGINALS = "Palavra passe errada";
export const CHANGE_DATA = "Dados alterados com sucesso";
export const ADD_DATA = "Dados adicionados com sucesso";
export const REMOVE_DATA = "Dados removidos com sucesso";
export const ERROR_DATA =
  "Não foi possível realizar a operação pretendida.";
export const disabledUser =
  "Seu acesso foi desactivado. Contata o suporte da aplicação.";
export const WorkerNumberWrongTitle = "Número do colaborador";
export const WorkerNumberWrongText =
  "Número do colaborador inexistente ou inativo, confirme se digitou o número correto ou contate o suporte da aplicação.";
export const WorkerNumberWrong =
  "Número do colaborador inexistente ou inativo, tente novamente ou contate o suporte da aplicação.";
export const WorkerNumberInactive =
"Número do colaborador inexistente ou inativo";
export const REMOVE_ACCOUNT = "Conta removida com sucesso";
export const NO_CONNECTION = "Sem ligação";
export const NO_SCHEDULE = "Não é possível fazer o agendamento";
export const ADD_SCHEDULE = "Agendamento realizado com sucesso";
export const REMOVE_SCHEDULE = "Agendamento removido";
export const CHANGE_SCHEDULE = "Agendamento alterado com sucesso";
export const UPDATE_ANDROID =
  "Existe uma versão mais recente da E-app. Atualiza a aplicação através das lojas: Google Play Store, para puderes beneficiar das novas funcionalidades.";
export const UPDATE_IOS =
  "Existe uma versão mais recente da E-app. Em breve será atualizada automaticamente, não necessitas que fazer nada. Qualquer questão contata o Departamento de comunicação.";

export const REGISTER =
  "Registo efetuado com sucesso, aguarde por favor e logo será redirecionado para a página inicial.";

export const CONTACT = "Mensagem enviada com sucesso.";
export const FOOD_SCHEDULED_ERROR =
  "Não existe agendamento para a data de hoje.";
export const notLogged = "Usuário não está logado";
export const NO_ROTA = "Rota não existe";


export const importantRecover = 'Caso este email esteja incorreto entre em contato com sabermais@volkswagen.pt'
export const NoLocation = "Não foi possivel obter a tua localização";
export const NoRotas = "Não existem rotas cadastradas";
export const NoCalendar = "Não existem datas cadastradas";
export const NoStops = "Não existem paragens próximas";

export const SEPARATOR = "&xCe8Y";
export const NEW_SEPARATOR = "xCeI12e8Y";
export const NAMETOKEN = "v10OMn&";
export const TitleMaintenance = "Manutenção";
export const MAINTENANCE = "A Eapp encontra-se em manutenção. Seremos breves.";
export const changePassSuccess =
  "Palavra passe alterada com sucesso. Iremos navegar para o inicio da eapp para que possa entrar com os novos dados.";
export const TitleLogins = "Múltiplos logins";
export const TextLogins =
  "Foi detetado que está com login noutro dispositivo, pelo que será desligado deste dispositivo: só é permitido um login, num dispositivo, por questões de segurança.";
export const TitleServerError = "Conexão interrompida";
export const TextServerError =
  "Estamos com problemas de ligação temporários. Por favor, tente novamente mais tarde.";
export const TitleUnauthorized = "Acesso não permitido";
export const UserUnauthorized =
  "A E-app é de acesso exclusivo a colaboradores da Volkswagen Autoeuropa. Tente fazer novo registo ou contacte o suporte.";
export const NotAvailable = "Não há mais vagas dísponíveis para esta data.";
export const ErrorTemp =
  "Não foi possível realizar a operação pretendida. Por favor, tente novamente mais tarde.";
  export const AuthNotAllowed = 'A escolha é obrigatória'
  export const TitleImage = 'Consentimento de imagem.'
  export const AuthImage =
  "<p>Consinto expressamente no tratamento dos meus dados de imagem e voz para captação, edição e posterior publicação das respetivas fotografias e vídeos em meios de comunicação internos e externos, pela Volkswagen Autoeuropa.</p>";
export const AuthImage2 = '<p>Poderá atualizar o seu consentimento a qualquer momento. Caso pretenda que a sua imagem não seja captada em determinada iniciativa e tenha previamente consentido na utilização da sua imagem, bastará carregar no botão “Li e não concordo” acima, e teremos em consideração a sua preferência. Ao retirar o consentimento, não compromete a licitude do tratamento efetuado com base no consentimento previamente dado. Para uma melhor gestão dos consentimentos fornecidos, solicitamos que atualize as suas preferências, pelo menos 1 dia antes de cada evento relativamente ao qual tenha sido informado que serão recolhidas imagens.</p><p>Saiba mais sobre como tratamos os seus dados na nossa política de privacidade</p>'


  

export const baseUrl = 'https://e-app-volkswagenportugal.com/api/'; ////voltar
export const urlImages = `${baseUrl}img/aur/`;
export const UrlHealth = `${baseUrl}utils/health`; 
export const UrlGraph = `${baseUrl}e-app-gql`; 

